angular.module('iw.frontyard.translate')
    .directive('iwTranslate', function (Translator, StringHelper) {

        return {
            restrict: 'A',
            scope: {
                interpolate: '=',
                pluralize: '=',
            },
            link: function ($scope, element, attributes) {
                var textToTranslate = getTextToTranslate(element);
                var translation = Translator.translate(textToTranslate);

                if (angular.isDefined($scope.interpolate)) {
                    translation = Translator.interpolate(translation, $scope.interpolate, true);
                }

                element.text(translation);

                $scope.$watch('pluralize', function (newValue, oldValue) {
                    if (newValue) {
                        var pluralized = Translator.pluralize(textToTranslate, attributes.plural, newValue);
                        element.text(pluralized);
                    }
                });

                function getTextToTranslate(element) {
                    if (attributes.disableTrim !== 'true') {
                        return StringHelper.trim(element.text());
                    }

                    if (angular.isDefined($scope.pluralize)) {
                        return Translator.pluralize(textToTranslate, attributes.plural, $scope.pluralize);
                    }

                    return element.text();
                }
            }
        };
    });
